export default __webpack_public_path__ + "static/media/virus.fd6289a0.png";